(() =>
{
  const DOMAIN = 'checkout.nadiia.world';

  const clearCart = () =>
  {
    const url = new URL(window.location.href);

    if (url.searchParams.get('clear_cart') === '1')
    {
      url.searchParams.delete('clear_cart');

      fetch('/cart/clear.js', {method: 'POST'}).then(() => window.location.href = url.toString());
    }
  }

  const sha256 = async (message) =>
  {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  }

  const submit = async (e) =>
  {
    e.preventDefault();

    const result = await fetch('/cart.json');

    if (result.status === 200)
    {
      const cart_params = await result.text();
      window.location.href = `https://${DOMAIN}/${document.documentElement.lang}/checkout?domain=${window.location.host}&cart_params=${encodeURIComponent(cart_params)}&sign=${await sha256(window.location.host + cart_params + '_checkout')}`;
    }
  }

  const init = () =>
  {
    document.querySelectorAll('form[action$="/cart"]').forEach((item) =>
    {
      item.removeEventListener('submit', submit);
      item.addEventListener('submit', submit);
    });
  }

  clearCart();

  setInterval(init, 1000);
  init();
})();